// 中文语言包
export default {
  nav: {
    home: '首页',
    products: '产品中心',
    solutions: '解决方案',
    about: '关于我们',
    contact: '联系我们'
  },
  common: {
    contactUs: '联系我们',
    logoText: '智控安防',
    language: '语言',
    chinese: '中文',
    english: 'English'
  }
}